/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
require('./scss');

const deps = [];

module.exports = angular.module('bench.ui.common.base', deps);
